import data_api from "./data_api";
import store from '@/store/index'
import utils from "./utils"

data_api.init();

export const init = () => {
    data_api.author.index()
    .then((resp) => {
      utils.console.log("author index resp: ", resp);
      store.set("author/list", resp);
      utils.console.log("store author list fater init: ", store.state.author.list);
    })
    .catch((error) => {
      console.error("author index faild: ", error)
    });

}

